import { render, staticRenderFns } from "./courseG.vue?vue&type=template&id=69ff9270&scoped=true&"
import script from "./courseG.vue?vue&type=script&lang=js&"
export * from "./courseG.vue?vue&type=script&lang=js&"
import style0 from "./courseG.vue?vue&type=style&index=0&id=69ff9270&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ff9270",
  null
  
)

export default component.exports